import React, { useState } from "react";
import PropTypes from "prop-types";
import Sidebar from "./components/sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import Header from "./components/header/Header";
import Breadcome from "../../components/ui/breadcome/Breadcome";
import Footer from "./components/footer/Footer";
import { InactivityDetector } from "../../lib/authenticationLibrary";

const Layout = (props) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebarCollapsed = () => {
    setSidebarCollapsed((prevState) => !prevState);
  };
  
  const inactivityTimeout =  30 * 60 * 1000;
  InactivityDetector(inactivityTimeout)

  return (
    <React.Fragment>
      <div className="main-page-layout">
        <div className="top-sec">
          <Sidebar
            componentRoutes={props.componentRoutes}
            sidebarCollapsed={sidebarCollapsed}
            toggleSidebarCollapsed={toggleSidebarCollapsed}
          />
          <div className={`middle-page-section`}>
            <Header />
            <div className="center-content-part">
              <div className="content-desc-section">
                <Breadcome componentRoutes={props.componentRoutes} />
                <div className="center-container">
                  <Outlet />
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

Layout.propTypes = {
  componentRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      element: PropTypes.element.isRequired,
      name: PropTypes.string,
    })
  ),
};

export default Layout;
